<template>
  <div class="block text-center">
    <div class="container text-center">
      <div class="row bg-white">
          <div class="col q-ma-lg text-left" style="font-size: 18px;">
            <h2 class="text-center">Philosophy &amp; Mission</h2>
            <p class="q-mt-lg">
              ChartFlow is an educational EHR system designed for all healthcare programs.
            </p>
            <p>
              ChartFlow accelerates the practice readiness of future healthcare providers worldwide. We do this by creating products that are accessible and affordable for all disciplines and geographies.
            </p>
            <p>
              The educator and learner experience drives every decision we make. With a tenured team spanning the globe and representing multiple disciplines we understand learning is not a single solution, but an evolving continuum. We believe in relationships that are transparent and accessible—reflected in everything we do from service to pricing with a focus on improving outcomes while lowering costs.
            </p>
            <p>
              We are doing our part to lower the total cost of learning and look forward to earning the chance to serve your future practitioners.
            </p>
          </div>
          <img class="gt-sm col" src="/svgdoctors.svg" alt=""/>
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: "FreeTrial",
});
</script>
<style scoped>
.block {
  padding: 3rem;
}

.container {
  display: flex;
  flex-direction: column; /* Stack elements vertically */
  justify-content: center;
  align-items: center; /* Center elements horizontally */
  text-align: center; /* Ensure text is centered */
  gap: 1rem; /* Space between elements */
  margin: 0 auto;
}

.footnote {
  font-size: 14px;
  line-height: 16px;
}

.start-free-trial {
  background-color: #2f76d3;
  color: white;
  border-radius: 30px;
  padding: 8px 6px;
  height: 45px;
}
</style>
